/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "./Header.scss";

function Header() {
  const [active, setActive] = useState(1);
  
  const scrollToSection = (elementId) => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const element = document.getElementById(elementId);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: "smooth",
        });
      }
    }
  };
  
  return (
    <div className="header-pinnacle">
      <span
        className={`menu-item ${active === 1 ? "active" : ""}`}
        onClick={() => {
          setActive(1);
          scrollToSection("project-synopsis");
        }}
      >
        Project Synopsis
      </span>
      <span
        className={`menu-item ${active === 2 ? "active" : ""}`}
        onClick={() => {
          setActive(2);
          scrollToSection("location");
        }}
      >
        Location
      </span>
      <span
        className={`menu-item ${active === 3 ? "active" : ""}`}
        onClick={() => {
          setActive(3);
          scrollToSection("project-specifications");
        }}
      >
        Project Specifications
      </span>
      <span
        className={`menu-item ${active === 4 ? "active" : ""}`}
        onClick={() => {
          setActive(4);
          scrollToSection("floor-plans");
        }}
      >
        Floor Plans
      </span>
      <span
        className={`menu-item ${active === 5 ? "active" : ""}`}
        onClick={() => {
          setActive(5);
          scrollToSection("gallery");
        }}
      >
        Gallery
      </span>
      <span
        className={`menu-item ${active === 6 ? "active" : ""}`}
        onClick={() => {
          setActive(6);
          scrollToSection("project-status");
        }}
      >
        Project Status
      </span>
    </div>
  );
}

export default Header;
